// Browser storage is optional; sensitive/session values stay in this tab's memory if blocked.
let degraded = false;
const fallback = { localStorage: new Map(), sessionStorage: new Map() };
const wrapper = name => ({
  getItem(key) {
    if (fallback[name].has(key)) return fallback[name].get(key);
    try { return window[name].getItem(key); } catch { degraded = true; return null; }
  },
  setItem(key, value) {
    try { window[name].setItem(key, String(value)); fallback[name].delete(key); return true; }
    catch { degraded = true; fallback[name].set(key, String(value)); return false; }
  },
  removeItem(key) {
    try { window[name].removeItem(key); fallback[name].delete(key); }
    catch { degraded = true; fallback[name].set(key, null); }
  },
  keys() {
    let stored = [];
    try { stored = Object.keys(window[name]); } catch { degraded = true; }
    return [...new Set([...stored, ...fallback[name].keys()])];
  }
});
export const safeLocalStorage = wrapper('localStorage');
export const safeSessionStorage = wrapper('sessionStorage');
export const storageDegraded = () => degraded;
